<template>
  <div>
    <titleSection/>
    <filterSection class="my-2" />
    <tableSection/>
  </div>
</template>

<script>
import titleSection from '@/components/_managesection/_overview/title.vue'
import filterSection from '@/components/_managesection/_overview/filter.vue'
import tableSection from '@/components/_managesection/_overview/table.vue'
export default {
  components: {
    titleSection, filterSection, tableSection
  }
}
</script>

<style scoped>
</style>
